import { Grid, GridSize, useTheme } from '@material-ui/core';
import { CSSProperties, FC, ReactNode } from 'react';
import { DataPathContextProvider } from '../CustomView';
import { CustomViewRegister } from '../CustomView/registry';

CustomViewRegister.register({
  id: 'new_root',
  function: function NewRoot(props: Record<string, any>) {
    return (
      <DataPathContextProvider path={props.path}>
        {props.children}
      </DataPathContextProvider>
    );
  },
});

export function computeItem(colSpan: number, gridColumns = 4) {
  // 12 is a full row in MUI grid
  const factor = 12 / gridColumns;

  return Math.min(12, colSpan * factor) as GridSize;
}

export const CustomViewGridElement: FC<{
  colSpan?: number;
  children: ReactNode;
  style?: CSSProperties;
  align?: string;
}> = ({ colSpan, children, style, align }) => {
  const theme = useTheme();

  return (
    <Grid
      item
      xs={computeItem(colSpan || 1, 1)}
      sm={computeItem(colSpan || 1, 2)}
      lg={computeItem(colSpan || 1, 4)}
      style={{
        ...{
          padding: `${theme.spacing(1)}px 0`,
          paddingRight: `${theme.spacing(3)}px`,
          paddingLeft: 0,
          textAlign: align as any,
        },
        ...style,
      }}
    >
      {children}
    </Grid>
  );
};
